<template>
  <booking-act
    v-if="config"
    :content="data"
    :config="config"
    :locale="locale"
    :isDesktop="false"
    :bookingWorkspaceID="bookingWorkspaceID"
    :filterType="filterType"
  />
  <!--booking-activities
    v-else-if="1==2 && config"
    :content="data"
    :config="config"
    :locale="locale"
    :isDesktop="false"
  /-->
</template>

<script>
import { mapState } from 'vuex'
import utils from '@/services/utils'
import api from '@/services/api'
//import BookingActivities from './BookingActivities'
import BookingAct from './BookingAct'
export default {
  components: {
    //BookingActivities,
    BookingAct,
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: null,
    },
    bookingWorkspaceID: {
      type: String,
      default: null,
    },
    filterType: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    config: null,
  }),
  computed: {
    ...mapState('app', ['locale', 'FontContent', 'FontSizeContent', 'ColorContent']),
    enterpriseID () {
      return utils.getEnterpiseID()
    },
  },
  mounted () {
    api.getItem('enterprises/config', false, this.enterpriseID)
      .then(response => {
        const aux = JSON.parse(JSON.stringify(response))
        this.config = aux
      })
  }
}
</script>
<style scoped>
</style>

